import apiClient from 'src/api/nestready/client'

const getFavoriteListings = customerId => {
  const client = apiClient(process.env.REACT_APP_NESTREADY_API_URL, customerId)
  return client.get(`/home_buyer/favorite_listings`)
}

const postToggleFavoriteListing = (listing, customerId) => {
  const client = apiClient(process.env.REACT_APP_NESTREADY_API_URL, customerId)
  return client.post(`/listings/${listing.id}/toggle_favorite`)
}

export { getFavoriteListings, postToggleFavoriteListing }
